
import { Component, Vue, Prop } from 'vue-property-decorator';
import { drawPoster, uploadImage } from '@components/h5/drawPoster';
import toast from '@bilibili/vanilla-toast';
import { bfsSize } from '@components/h5/filter';
import { store } from '@/common/store';
import { uploadAvatarImg, isScreen } from '@/common/api';
import logger from '@plat-components/utils2/_esm5/logger'
import { sharePanel, saveImageToPhotosAlbum } from '@components/h5/initShare';
import { initOpenBiliApp } from '@js/openApp';
import { inBiliApp } from '@bilibili/js-bridge';

@Component({
  name: 'PosterDialog',
})
export default class PosterDialog extends Vue {
  @Prop({ default: false, required: false})visible!: boolean;
  @Prop({}) posterName!: string

  isScreen= isScreen
  posterUrl = '';
  posterBaseUrl = '';
  posterFlag = 1;

  get getUserInfo() {
    return store.userInfo || false;
  }

  async localStorageUrl(num: number) {
    const imgBlob = await drawPoster(this.posterFlag);
    const picUrl = await uploadAvatarImg(imgBlob.toString(), '');
    // 发动态需要接海报审核，需要在图片链接里加特定参数（from=bili）
    this.posterUrl = bfsSize(picUrl || '', 514, 914);
    localStorage.setItem(`poster_${num}_${this.getUserInfo.mid}`, this.posterUrl);
  }

  async getPosterImage() {
    try {
      const imgBlobBase = await drawPoster(this.posterFlag);
      this.posterBaseUrl = imgBlobBase as any;
      localStorage.setItem(
          `posterBase64_${this.posterFlag}_${this.getUserInfo.mid}`,
          this.posterBaseUrl
      );
    } catch (err) {
      // toast.info('生成海报失败，请稍后再试～');
    }
  }

  async posterShow(num: any) {
    this.posterFlag = num
    const cacheUrl = localStorage.getItem(`poster_${num}_${this.getUserInfo.mid}`);
    const cacheBaseUrl = localStorage.getItem(`posterBase64_${num}_${this.getUserInfo.mid}`);
    if (cacheUrl) {
      this.posterUrl = cacheUrl;
    } else {
      this.localStorageUrl(num)
    }
    if (cacheBaseUrl) {
      this.posterBaseUrl = cacheBaseUrl
    } else {
      this.getPosterImage();
    }
  }

  async close() {
    this.$emit('onClose');
    document.body.style.overflow = 'auto';
  }

  savePoster() {
    logger(`save_poster_custom_${this.posterName}`);
    if (!this.posterBaseUrl) {
      toast.info('海报生成中，请稍后再试~');
      return;
    }
    logger(`save_poster_click_${this.posterName}`)

    saveImageToPhotosAlbum(this.posterBaseUrl, 'poster', (message: string) => {
      toast.success(message, {
        duration: 3000,
        customStyle: {
          backgroundColor: '#000',
          color: '#fff',
        },
      });
    });
  }

  async handleSharePoster() {
    logger(`share_poster_custom_${this.posterName}`);
    if (!this.posterBaseUrl) {
      toast.info('海报生成中，请稍后再试~');
      return;
    }
    if (!inBiliApp) {
      initOpenBiliApp();
      return;
    }
    logger(`share_poster_click_${this.posterName}`)
    // 本地存储海报url
    if (!this.posterUrl) {
      await this.localStorageUrl(this.posterFlag);
      sharePanel(this.posterUrl);
    } else {
      sharePanel(this.posterUrl);
    }
  }
}
